
import MyBetCombinationModel from './model-mybet-combination';
import MyBetItemsModel from './model-mybet-items';
import { DateFilterService } from '@bto-services/utils';

export default class MyBetDetailsModel {
  constructor(data) {
    const group = data.g;
    const combinations = data.c;
    const items = data.i;
    /**
     * @type {number}
     */
    this.betSlipGroupID = group.id;
    /**
     * @type {string}
     */
    this.betSlipGroupStatus = group.st;
    /**
     * @type {number}
     */
    this.betSlipGroupStatusId = group.stid;
    /**
     * @type {string}
     */
    this.betSlipGroupType = group.t;
    /**
     * @type {number}
     */
    this.betSlipGroupTypeId = group.tid;
    /**
     * @type {string}
     */
    this.matchesType = group.mt;
    /**
     * @type {string}
     */
    this.createdOn = DateFilterService.localDate(
      group.c,
      'datetime',
      APP_SETTINGS.formatting.fullDateFormat,
      APP_SETTINGS.formatting.fullTimeFormat,
      true
    );
    /**
     * @type {string}
     */
    this.createdDate = DateFilterService.localDate(
      group.c,
      'date',
      APP_SETTINGS.formatting.fullDateFormat,
      '',
      true
    );
    /**
     * @type {string}
     */
    this.createdTime = DateFilterService.localDate(
      group.c,
      'time',
      '',
      APP_SETTINGS.formatting.fullTimeFormat,
      true
    );
    /**
     * @type {string}
     */
    this.datetime = group.c;
    /**
     * @type {string}
     */
    this.username = group.un;
    /**
     * @type {string}
     */
    this.fullUsername = group.ufn;
    /**
     * @type {string}
     */
    this.currencyCode = group.cc;
    /**
     * @type {boolean}
     */
    this.paid = group.p;
    /**
     * @type {string}
     */
    this.identifier = group.i;
    /**
     * @type {string}
     */
    this.civilId = group.cid;
    /**
     * @type {string}
     */
    this.currentUserName = group.cun;
    /**
     * @type {MyBetCombinationModel[]}
     */
    this.combinations = combinations.map(c => new MyBetCombinationModel(c)) || [];
    /**
     * @type {MyBetItemsModel[]}
     */
    this.items = items.map(i => new MyBetItemsModel(i)) || [];
    /**
     * @type {boolean}
     */
    this.printed = group.pr;

    const { totalStake, totalBonus, totalPotWinnings, totalWinnings, totalTax, totalNumOfBets, totalUnitStake } = this.combinations.reduce((prev, next) => {
      let totals = {
        totalStake: prev.totalStake += next.stake,
        totalBonus: prev.totalBonus += next.bonus,
        totalPotWinnings: prev.totalPotWinnings += next.potWinnings,
        totalWinnings: prev.totalWinnings += next.winnings,
        totalTax: prev.totalTax += next.tax,
        totalNumOfBets: prev.totalNumOfBets += next.numOfBets,
        totalUnitStake: prev.totalUnitStake += next.unitStake,
      };
      return totals;
    }, {
      totalStake: 0,
      totalUnitStake: 0,
      totalBonus: 0,
      totalPotWinnings: 0,
      totalWinnings: 0,
      totalTax: 0,
      totalNumOfBets: 0,
    });
    /**
     * Totals from combinations
     */
    this.stake = totalStake;
    this.unitStake = totalUnitStake;
    this.bonus = totalBonus;
    this.potWinnings = totalPotWinnings;
    this.winnings = totalWinnings;
    this.tax = totalTax;
    this.totalNumOfBets = totalNumOfBets;
  }
}
